import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './router' // 导入路由配置
import i18n from '@/utils/LangManager' // 导入 i18n 配置
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import('@/styles/variables.less')

// 导入组件
import LangBox from '@/components/LangBox.vue'
// 全局注册组件
Vue.component('LangBox', LangBox)

let defLang = localStorage.getItem('lang')

if (defLang) {
    i18n.locale = defLang
}
Vue.use(ElementUI)
Vue.use(VueRouter)
const router = new VueRouter({
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 } // Scroll to top of the page
        }
    }
})
new Vue({
    i18n,
    router, // 注册路由
    render: (h) => h(App)
}).$mount('#app')
